import DateTimePicker from "@/components/DateTimePicker.tsx"
import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form.tsx"

import type { DataPointReportBuilderSchema } from "./DataPointReportBuilder.tsx"
import type { UseFormReturn } from "react-hook-form"

export default function ConstantRangeSelector({
  form,
}: {
  form: UseFormReturn<DataPointReportBuilderSchema>
}) {
  return (
    <>
      <FormField
        control={form.control}
        name="range.start"
        render={({ field }) => (
          <FormItem className="col-span-2">
            <FormLabel>Start Date</FormLabel>
            <FormControl>
              <DateTimePicker {...field} />
            </FormControl>
            <FormMessage />
            <FormDescription>Date in current timezone</FormDescription>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name="range.end"
        render={({ field }) => (
          <FormItem className="col-span-2">
            <FormLabel>End Date</FormLabel>
            <FormControl>
              <DateTimePicker {...field} />
            </FormControl>
            <FormMessage />
            <FormDescription>Date in current timezone</FormDescription>
          </FormItem>
        )}
      />
    </>
  )
}
